import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { SendWhatsappTemplateDialogComponent } from './send-whatsapp-template-dialog.component'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class SendWhatsappTemplateDialogService {
  constructor(private dialog: DialogService) {}

  open(inquiry: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '750px',
      height: 'auto',
      data: {
        inquiry,
      },
    }

    return this.dialog.openVariableDialog(SendWhatsappTemplateDialogComponent, defaultConfig)
  }
}
